module.exports = {"530102001":"华山街道","530102002":"护国街道","530102003":"大观街道","530102004":"龙翔街道","530102005":"丰宁街道","530102006":"莲华街道","530102007":"红云街道","530102008":"黑林铺街道","530102009":"普吉街道","530102010":"西翥街道","530102401":"昆明国家高新技术产业开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530102.json
// module id = 2350
// module chunks = 0